export interface UpdateAirportsActionPayload {
  fromCity: string;
  toCity: string;
  fromCityName?: string;
  toCityName?: string;
}
